<template>
    <div class="pie-chart" :style="pieStyle"></div>
</template>

<script>
export default {
    name: "CollectablePie",
    props: [
        'pieSlice'
    ],
    computed: {
        pieStyle() {
            let sum = 0;
            let styles = this.pieSlice.map(
                piePart => `${piePart.color} 0 ${sum += piePart.value}%`
            );
            return {
                background: 'conic-gradient(' + styles.join(",") + ')'
            };
        }
    }
}
</script>

<style scoped>
.pie-chart {
    flex: 2 0 auto;
    width: 41px;
    height: 41px;
    border-radius: 50%;
    border: 1px solid var(--darkest);
    margin: 4px;
}
</style>
